import React from 'react';

const DEFAULT_LANGUAGE = 'fr';

const LanguageContext = React.createContext(
    DEFAULT_LANGUAGE,
);

export { LanguageContext, DEFAULT_LANGUAGE };



// WEBPACK FOOTER //
// ./src/translations/languageContext.js